<template>
  <div>
    <BaseHeader>
      <template v-slot:title>Privacy Policy</template>
    </BaseHeader>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'

import { BaseHeader } from '@/components/base'

export default defineComponent({
  name: 'PrivacyPolicy',
  title: 'Privacy Policy',
  components: {
    BaseHeader
  }
})
</script>
